module.exports = __webpack_public_path__ + "img/product5.fcb3d6a9.png";